import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Container, Row, Col, Card, Spinner, Alert } from "react-bootstrap";
// import { createGlobalStyle } from 'styled-components'; // Removido
import { getClienteMasterBySlug } from "../../../services/endpoints";
// import { getContrastingTextColor, generateContrastPalette } from '../../../utils/colorUtils'; // Removido
import { useColors } from '../../../contexts/ColorContext'; // Adicionado

function InicioOpcoes() {
  const navigate = useNavigate();
  const { slug } = useParams();
  const [clienteMaster, setClienteMaster] = useState(null);
  const [isServiceActive, setIsServiceActive] = useState(true);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Hook de cores
  const { updateColors } = useColors();

  useEffect(() => {
    async function fetchClienteMaster() {
      try {
        // Não chamamos setLoading(true) aqui, pois o estado inicial já é true
        const data = await getClienteMasterBySlug(slug);
        setClienteMaster(data);
        // Verifica o novo campo 'ativo'
        if (data && data.ativo === false) {
          setIsServiceActive(false);
        } else {
          setIsServiceActive(true);
        }
        
        // **APLICAÇÃO DA COR CORRIGIDA**
        // Se houver configuração de cores, atualiza o contexto
        if (data && data.configuracaoCores) {
          updateColors(data.configuracaoCores);
        }
        
      } catch (err) {
        console.error("Erro ao buscar ClienteMaster por slug:", err);
        setError("Não foi possível carregar as informações do cliente. Verifique a URL.");
      } finally {
        // O setLoading(false) deve ser o último a ser chamado para que a tela só
        // seja renderizada após a aplicação das cores.
        setLoading(false);
      }
    }

    if (slug) {
      fetchClienteMaster();
    }
  }, [slug, updateColors]);

  // Removido: Lógica de cores e estilos globais que estava aqui.
  // A aplicação das cores agora é feita via CSS Variables no ColorContext.

  if (loading) {
    return (
      <Container className="py-5 text-center">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Carregando...</span>
        </Spinner>
        <p className="mt-3">Carregando informações do cliente...</p>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="py-5 text-center">
        <Alert variant="danger">{error}</Alert>
      </Container>
    );
  }

  if (!clienteMaster) {
    return (
      <Container className="py-5 text-center">
        <Alert variant="warning">Cliente não encontrado.</Alert>
      </Container>
    );
  }

  // Componente de Overlay para bloqueio visual
  const BlockOverlay = () => (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(255, 255, 255, 0.8)', // Fundo branco semi-transparente para "nublar"
      backdropFilter: 'blur(5px)', // Efeito de desfoque
      zIndex: 1000,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      textAlign: 'center',
      padding: '20px',
    }}>
      <h1 style={{ color: 'red' }}>Serviço Desativado</h1>
      <p style={{ fontSize: '1.2rem' }}>
        O serviço de agendamento para **{clienteMaster.nome}** está temporariamente inativo.
      </p>
      <p style={{ fontSize: '1.2rem' }}>
        Por favor, entre em contato com o suporte para mais informações.
      </p>
    </div>
  );
return (
    <>
      {/* Removido: Estilos globais desnecessários, o ColorContext já aplica via CSS Variables */}
      {!isServiceActive && <BlockOverlay />}
      <Container
        className="py-5"
        // Removido: Estilos inline desnecessários
      >
        <h2 className="text-center mb-4 titulo">
          Bem-vindo(a) à {clienteMaster.nome}!
        </h2>
        <h3 className="text-center mb-4 titulo">
          O que você deseja fazer?
        </h3>

        <Row className="justify-content-center g-4">
          <Col
            xs={12}
            sm={8}
            md={6}
            lg={4}
            className="d-flex justify-content-center"
          >
            <Card
              className="text-center shadow-sm h-100"
              style={{ width: "100%", maxWidth: "300px" }}
            >
              <Card.Body className="d-flex flex-column">
                <Card.Title className="card-content">Novo Agendamento</Card.Title>
                <Card.Text className="flex-grow-1 card-content">
                  Clique para iniciar um novo agendamento passo a passo.
                </Card.Text>
                <Button
                  variant="primary"
                  onClick={() => navigate(`/${slug}/agendamentos`)}
                  // Removido: Estilos inline desnecessários
                >
                  Agendar
                </Button>
              </Card.Body>
            </Card>
          </Col>

          <Col
            xs={12}
            sm={8}
            md={6}
            lg={4}
            className="d-flex justify-content-center"
          >
            <Card
              className="text-center shadow-sm h-100"
              style={{ width: "100%", maxWidth: "300px" }}
            >
              <Card.Body className="d-flex flex-column">
                <Card.Title className="card-content">
                  Consultar / Excluir Agendamentos
                </Card.Title>
                <Card.Text className="flex-grow-1 card-content">
                  Veja seus agendamentos existentes e remova se necessário.
                </Card.Text>
                <Button
                  variant="primary" // Alterado para secondary para usar a cor secundária
                  onClick={() => navigate(`/${slug}/consultar-agendamentos`)}
                  // Removido: Estilos inline desnecessários
                >
                  Consultar Agendamentos
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default InicioOpcoes;